/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximum3subcategoriesallowed2Inputs */

const en_maximum3subcategoriesallowed2 = /** @type {(inputs: Maximum3subcategoriesallowed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum 3 subcategories allowed`)
};

const de_maximum3subcategoriesallowed2 = /** @type {(inputs: Maximum3subcategoriesallowed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximal 3 Unterkategorien erlaubt`)
};

/**
* | output |
* | --- |
* | "Maximum 3 subcategories allowed" |
*
* @param {Maximum3subcategoriesallowed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maximum3subcategoriesallowed2 = /** @type {((inputs?: Maximum3subcategoriesallowed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximum3subcategoriesallowed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maximum3subcategoriesallowed2(inputs)
	return de_maximum3subcategoriesallowed2(inputs)
});
export { maximum3subcategoriesallowed2 as "maximum3SubcategoriesAllowed" }